<template>
  <status-base status="failure">
    <template v-slot:title>
      Este passageiro não<br>
      pertence a este ônibus
    </template>

    <template v-slot:subtitle>
      Verifique as informações
    </template>

    <template v-slot:btn>
      Voltar
    </template>
  </status-base>
</template>

<script>
  import StatusBase from './Base.vue'

  export default {
    name: 'Failure',

    components: {
      StatusBase,
    },
  }
</script>
